import {
    MtBillingHistory,
    MtCart,
    MtCartCreate,
    MtPaymentIntent,
} from "server/models"
import { GET, POST, DELETE } from "client/store/utils"
import {
    StripePaymentIntent,
    StripePaymentIntentData,
} from "client/store"


// stripe

export const LoadStripeKey = () => (
    GET("/stripe/loadStripeKey")
    .then((publicKey: string) => publicKey)
)

export const GetStripePaymentIntent = (id: string) => (
    GET(`/stripe/getPaymentIntent/${id}`)
    .then((paymentIntent: StripePaymentIntent) => paymentIntent)
)

export const EditStripePaymentIntent = (data: StripePaymentIntentData) => (
    POST(
        "/stripe/editPaymentIntent",
        JSON.stringify(data),
    ).then((paymentIntentId: string) => paymentIntentId)
)

export const CancelStripePaymentIntent = (id: string) => (
    DELETE(`/stripe/cancel/${id}`)
    .then((paymentIntent: StripePaymentIntent) => paymentIntent)
)

// payment intent

export const GetMtPaymentIntent = (accountId: number, userId: number) => (
    GET(`/mtPaymentIntent/accountId/${accountId}/userId/${userId}`)
    .then((paymentIntent: MtPaymentIntent) => paymentIntent)
)

export const SaveMtPaymentIntent = (paymentIntent: MtPaymentIntent) => (
    POST(
        "/mtPaymentIntent/save",
        JSON.stringify(paymentIntent),
    )
)

export const DeleteMtPaymentIntent = (accountId: number, userId: number, paymentIntentId: string) => (
    DELETE(`/mtPaymentIntent/delete/${accountId}/${userId}/${paymentIntentId}`)
    .then((removedRows: number) => removedRows)
)

// cart

export const LoadCartData = (accountId: number, userId: number) => (
    GET(`/mtCart/accountId/${accountId}/userId/${userId}`)
    .then((res: MtCart[]) => res)
)

export const CreateCartData = (data: MtCartCreate) => (
    POST(
        "/mtCart/add",
        JSON.stringify(data),
    ).then((res: MtCart) => res)
)

export const RestoreCartData = (data: MtCart) => (
    POST(
        "/mtCart/restore",
        JSON.stringify(data),
    ).then((res: MtCart) => res)
)

export const DeleteCartData = (id: number, accountId: number, userId: number) => (
    DELETE(`/mtCart/delete/${id}/${accountId}/${userId}`)
    .then((removedRows: number) => removedRows)
)

export const DeleteAllCartData = (accountId: number, userId: number) => (
    DELETE(`/mtCart/deleteAll/${accountId}/${userId}`)
    .then((removedRows: number) => removedRows)
)

// billing history

export const LoadBillingHistory = (accountId: number) => (
    GET(`/mtBillingHistory/accountId/${accountId}`)
    .then((res: MtBillingHistory[]) => res)
)

export const DeleteBillingHistory = (id: number, accountId: number) => (
    DELETE(`/mtBillingHistory/delete/${id}/${accountId}`)
    .then((removedRows: number) => removedRows)
)

// help functions

export const ActivePackageDaysLeft = (dateEnd: Date) => {
    const endTime = new Date(dateEnd).getTime()
    const nowTime = new Date().getTime()

    const secondTime = 1000 // milliseconds
    const minuteTime = 60 * secondTime
    const hourTime = 60 * minuteTime
    const dayTime = 24 * hourTime

    const inDays = endTime > nowTime
        ? Math.floor((endTime - nowTime) / dayTime)
        : 0

    return inDays
}

export const PackageAlmostExpireTime = () => {
    const secondTime = 1000 // milliseconds
    const minuteTime = 60 * secondTime
    const hourTime = 60 * minuteTime
    const dayTime = 24 * hourTime
    const threeMonth = 90 * dayTime

    return threeMonth
}
